var config = require("./config");
var Path = require("path");
var { stringify } = require("./queryString");

exports.url = function url(value, opts) {
  if (value && /^\/[^\/]/.test(value)) {
    var root = config.urlRoot || "";
    value = root.replace(/\/$/, "") + "/" + (value || "").replace(/^\//, "");
  }
  if (value && opts) {
    value = value + (value.indexOf("?") === -1 ? "?" : "&") + stringify(opts);
  }
  return value;
};

exports.skinUrl = function skinUrl(value) {
  return Path.join(
    config.urlRoot || "/",
    "content/less/themes/",
    config.currentSkin,
    value,
  );
};

/**
 * Removes HTML tags from a given string.
 *
 * @param {string} textToRemovehtml - The HTML string from which to remove HTML tags.
 * @returns {string} - The string with HTML tags removed.
 */
exports.removehtml = function removehtml(textToRemovehtml) {
  const parser = new DOMParser();
  const descriptionDoc = parser.parseFromString(textToRemovehtml, "text/html");
  return descriptionDoc.body.textContent || "";
};

exports.decode = function decodeHtml(textToDecode) {
  if (!textToDecode || typeof textToDecode !== "string") {
    return "";
  }
  const doc = new DOMParser().parseFromString(textToDecode, "text/html");
  return doc.documentElement.textContent;
};
